import { flushSync } from 'react-dom';
import React, { useState, useEffect, useContext, useRef } from 'react';
import { LegacyStack, Text } from '@shopify/polaris';
import Address from './Address'
import ProxyForm from '../ProxyForm'
import EditPassword from '../../EditPassword'
import EditContact from '../../EditContact'
import { CustomerContext } from '../../contexts/Customer'
import { ShopContext } from '../../contexts/Shop'
import { HostContext } from '../../contexts/Host'
import { FormProvider, useFetch, Util } from '@thinkwell/react.common'
import { ProductsContext } from "../../contexts/Products";
import { ProductsYolkContext } from "../../contexts/yolk/Products";
import { Spinner } from "@thinkwell/react.polaris";

export default function Resources(props) {
  const host = useContext(HostContext)
  const [products] = useContext(ProductsContext)
  const [productsYolk, fetchProductsYolk, fetchProductsYolkState] = useContext(ProductsYolkContext)

  useEffect(() => {
    if(products && products.length) {
      fetchProductsYolk(`${host}/accounts/products.json`, {sku: products.map(product => product.sku)});
    }
  }, [])

  if (fetchProductsYolkState.loading) {
    return <Spinner active={true} />
  }

  const productsWithResources = (productsYolk || []).filter(productYolk => productYolk.resources && productYolk.resources.length)
  if (!productsWithResources.length) {
    return null
  }

  return (<table style={{width: "100%"}}><tbody>
  {
    productsWithResources.map(productYolk => {
    return (<tr key={productYolk.id}><td><div className="row">
      <div className="columns large-6">
        <h2><Text as="span" fontWeight="semibold">{productYolk.title}</Text></h2>
        <LegacyStack vertical={true}>
          {
            (productYolk.resources.map(resource => {
              return (<a key={resource.title} href={resource.url} target="_blank">{resource.title}</a>)
            }))}
        </LegacyStack>
      </div>
    </div></td></tr>)
    })}
    </tbody></table>)
}
